import React from 'react';
import { Route } from 'react-router-dom';

import GA from '../../ga';

// Idea from:
// https://github.com/ReactTraining/react-router/issues/4278#issuecomment-278477167

const logPageView = () => {
  GA.set({
    page: `${window.location.pathname}${window.location.search}`,
    title: window.document.title,
  });
  GA.pageview(`${window.location.pathname}${window.location.search}`);
  return null;
};

const LogPageView = () => <Route path="/" component={logPageView} />;

export default LogPageView;
